import { render } from "./Column202602.vue?vue&type=template&id=5467c380&scoped=true"
import script from "./Column202602.vue?vue&type=script&lang=js"
export * from "./Column202602.vue?vue&type=script&lang=js"

import "./Column202602.vue?vue&type=style&index=0&id=5467c380&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5467c380"]])

export default __exports__